import React, { useState, useEffect } from "react";
import { useParams, Outlet, Navigate } from "react-router-dom";
import betaAPI from "v2/api";
import V2NotFound from "v2/views/V2NotFound";

const V2ProtectedRoute = () => {
  const { workspaceId } = useParams();
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [workspaces, setWorkspaces] = useState([]);

  useEffect(() => {
    const validateAccess = async () => {
      try {
        const response = await betaAPI.getWorkspaces();
        const workspaceList = response.data?.workspaces || [];
        setWorkspaces(workspaceList);

        // Check if user has access to the requested workspace. Superadmins
        // can open any workspace (the backend already bypasses membership
        // for them) — e.g. following a session from the wearable admin.
        const user = JSON.parse(localStorage.getItem("user") || "null");
        const hasWorkspaceAccess =
          user?.is_superadmin === true ||
          workspaceList.some((w) => String(w.id) === String(workspaceId));
        setHasAccess(hasWorkspaceAccess);
      } catch (err) {
        console.error("Failed to validate workspace access:", err);
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    };

    if (workspaceId) {
      validateAccess();
    } else {
      setLoading(false);
    }
  }, [workspaceId]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F8F9FA]">
        <div className="border-t-transparent h-8 w-8 animate-spin rounded-full border-2 border-[#E07A3A]" />
      </div>
    );
  }

  // If no workspaceId in URL, redirect to default
  if (!workspaceId) {
    return <Navigate to="/v2" replace />;
  }

  // If user doesn't have access, show 404 (don't leak that workspace exists)
  if (!hasAccess) {
    return <V2NotFound />;
  }

  // User has access, render children with workspace context
  return <Outlet context={{ workspaces }} />;
};

export default V2ProtectedRoute;
